import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M5.5 12.7499V11.25H18.5V12.7499H5.5Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map